import React, { useState, useRef, useEffect } from 'react';
import styled from 'styled-components';

const SelectContainer = styled.div`
  position: relative;
  width: 200px;
  user-select: none;
`;

const SelectedValue = styled.div`
  padding: 10px;
  border: 1px solid #7455BF;;
  border-radius: 8px;
  background-color: transparent;
  backdrop-filter: blur(100px);
  font-size: 16px;
  cursor: pointer;
  &:focus {
    outline: none;
  }
`;

const DropdownIcon = styled.span`
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
  font-size: 14px;
  color: #666;
`;

const OptionsList = styled.ul`
  position: absolute;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
  border: 1px solid #7455BF;
  border-top: none;
  border-radius: 0 0 8px 8px;
  background-color:#1a1936;
  backdrop-filter: blur(100px);
  z-index: 1000;
  max-height: 200px;
  overflow-y: auto;
`;

const OptionItem = styled.li`
  padding: 10px;
  cursor: pointer;
`;

const CustomSelect = ({ options, value, onChange, placeholder = 'Select an option' ,style}) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  const handleToggle = () => {
    setIsOpen(prev => !prev);
  };

  const handleOptionClick = (optionValue) => {
    onChange(optionValue);
    setIsOpen(false);
  };

  // Close dropdown when clicking outside
  const handleClickOutside = (event) => {
    if (containerRef.current && !containerRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const selectedOption = options.find(opt => opt.value === value);

  return (
    <SelectContainer style={style} ref={containerRef}>
      <SelectedValue onClick={handleToggle} tabIndex={0}>
        {selectedOption ? selectedOption.label : placeholder}
      </SelectedValue>
      <DropdownIcon>&#9662;</DropdownIcon>
      {isOpen && (
        <OptionsList>
          {options.map(option => (
            <OptionItem key={option.value} onClick={() => handleOptionClick(option.value)}>
              {option.label}
            </OptionItem>
          ))}
        </OptionsList>
      )}
    </SelectContainer>
  );
};

export default CustomSelect;
